export default {
  examManagerApi: {
    examQuestionBank: {
      downloadTemplate: '/api/examQuestionBank/downloadTemplate',
      importData: '/api/examQuestionBank/importData',
      getBankList: '/api/examQuestionBank/getBankList',
      delBanks: '/api/examQuestionBank/delBanks',
      saveOrUpdateBank: '/api/examQuestionBank/saveOrUpdateBank',
      getBankQuestionList: '/api/examQuestionBank/getBankQuestionList',
      getList: '/api/examQuestionBank/getList',
      delQuestions: '/api/examQuestionBank/delQuestions',
      saveOrUpdate: '/api/examQuestionBank/saveOrUpdate',
      randomQuestions: '/api/examQuestionBank/randomQuestions'
    },
    examPaper: {
      getList: '/api/examPaper/getList',
      delPapers: '/api/examPaper/delPapers',
      saveOrUpdate: '/api/examPaper/saveOrUpdate',
      getDetail: '/api/examPaper/getDetail',
      getPaperDetail: '/api/examPaper/getPaperDetail',
      getStartList: '/api/examPaper/getStartList',
      bankList: '/api/examPaper/bankList',
      getPaperRoles: '/api/examPaper/getPaperRoles',
      getPaperUsers: '/api/examPaper/getPaperUsers',
      checkConnect: '/api/examPaper/checkConnect',
      checkCanExam: '/api/examPaper/checkCanExam',
      submit: '/api/examPaper/submit',
      getHistoryList: '/api/examPaper/getHistoryList',
      getPaperTranscript: '/api/examPaper/getPaperTranscript',
      getPaperScoring: '/api/examPaper/getPaperScoring',
      saveScore: '/api/examPaper/saveScore'
    }
  }
}